/** @jsx React.DOM */
var React = require('react/addons')

var News = React.createClass({displayName: 'News',
  render: function() {
    return React.DOM.div({className: "news"}, 
      React.DOM.h3(null, "RMC web wallet"), 
      React.DOM.p(null, "Try ", React.DOM.a({href: "https://wallet.rmc.one/"}, "wallet.rmc.one"), " for maximum portability"), 

      React.DOM.h3(null, "RMC wallet software"), 
      React.DOM.p(null, "Builds: MacOS 64 bit (", React.DOM.a({href: "builds/RMCWallet.zip"}, "ZIP"), ", ", React.DOM.a({href: "builds/RMCWallet.tar.xz"}, "TAR.XZ"), "), ", React.DOM.a({href: "builds/RMCWallet.exe"}, "Windows 64-bit")), 
      React.DOM.p(null, "Source code: ", React.DOM.a({target: "_blank", href: "https://github.com/RussianMiningCoin/RMCWallet"}, "Github")), 

      React.DOM.h3(null, "RMC node daemon"), 
      React.DOM.p(null, "Source code: ", React.DOM.a({target: "_blank", href: "https://github.com/RussianMiningCoin/rmcd"}, "Github"))
    )
  }
})

module.exports = News



//////////////////
// WEBPACK FOOTER
// ./src/routes/home/news.jsx
// module id = 463
// module chunks = 0